import { AxiosService } from '../../axios/axios.service.ts';

export type tSteeringInstruction = {
  id: string;
  text: string;
  set_by_name: string;
  set_at: string;
};

export const steeringService = Object.freeze({
  appendSteering: async function (
    workspaceId: string,
    chatId: string,
    text: string,
  ): Promise<tSteeringInstruction> {
    return AxiosService.post<{ text: string }, tSteeringInstruction>(
      `/ai/workspaces/${workspaceId}/chats/${chatId}/steer`,
      { text },
      { isLegacy: false },
    );
  },

  getInstructions: async function (
    workspaceId: string,
    chatId: string,
  ): Promise<tSteeringInstruction[]> {
    return AxiosService.get<tSteeringInstruction[]>(
      `/ai/workspaces/${workspaceId}/chats/${chatId}/steer`,
      { isLegacy: false },
    );
  },

  deleteInstruction: async function (
    workspaceId: string,
    chatId: string,
    instructionId: string,
  ): Promise<void> {
    return AxiosService.delete<void>(
      `/ai/workspaces/${workspaceId}/chats/${chatId}/steer/${instructionId}`,
      { isLegacy: false },
    );
  },

  clearAll: async function (workspaceId: string, chatId: string): Promise<void> {
    return AxiosService.delete<void>(
      `/ai/workspaces/${workspaceId}/chats/${chatId}/steer`,
      { isLegacy: false },
    );
  },
});
